import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ScrollToTop from 'components/ScrollToTop';
import ErrorBoundary from 'components/ErrorBoundary';
import { ScreenErrorBoundary } from './utils/errorBoundaries';
import NotFound from 'pages/NotFound';
import CrimeHub from './pages/crime-hub';
import Portfolio from './pages/portfolio';
import Dashboard from './pages/dashboard';
import StockExchange from './pages/stock-exchange';
import StockDetail from './pages/stock-detail';
import Businesses from './pages/businesses';
import JailPage from './pages/jail';
import FactionsPage from './pages/factions';
import WarsPage from './pages/wars';
import MarketplacePage from './pages/marketplace';
import LeaderboardsPage from './pages/leaderboards';
import ProfilePage from './pages/profile';
import NotificationsPage from './pages/notifications';
import AdminPanelPage from './pages/admin';
import EconomyDashboardPage from './pages/economy-dashboard';
import QuestsAchievements from './pages/quests-achievements';
import FactionChat from './pages/faction-chat';
import SeasonalEventsPage from './pages/seasonal-events';
import SeasonPassPage from './pages/season-pass';
import SignInPage from './pages/sign-in';
import RegisterPage from './pages/register';
import ProtectedRoute from './components/ProtectedRoute';
import EconomyStatisticsPage from './pages/economy-statistics';
import AdminDashboardPage from './pages/admin-dashboard';
import ResetPasswordPage from './pages/reset-password';

const withScreenBoundary = (Component, name) => {
  const Wrapped = (props) => (
    <ScreenErrorBoundary name={name}>
      <Component {...props} />
    </ScreenErrorBoundary>
  );
  Wrapped.displayName = 'withScreenBoundary(' + name + ')';
  return Wrapped;
};

const withProtection = (Component, name) => {
  const Wrapped = (props) => (
    <ProtectedRoute>
      <ScreenErrorBoundary name={name}>
        <Component {...props} />
      </ScreenErrorBoundary>
    </ProtectedRoute>
  );
  Wrapped.displayName = 'withProtection(' + name + ')';
  return Wrapped;
};

const SignIn = withScreenBoundary(SignInPage, 'SignIn');
const Register = withScreenBoundary(RegisterPage, 'Register');
const ResetPass = withScreenBoundary(ResetPasswordPage, 'ResetPassword');
const DashboardPage = withProtection(Dashboard, 'Dashboard');
const StockExchangePage = withProtection(StockExchange, 'StockExchange');
const StockDetailPage = withProtection(StockDetail, 'StockDetail');
const PortfolioPage = withProtection(Portfolio, 'Portfolio');
const BusinessesPage = withProtection(Businesses, 'Businesses');
const CrimeHubPage = withProtection(CrimeHub, 'CrimeHub');
const Jail = withProtection(JailPage, 'Jail');
const Factions = withProtection(FactionsPage, 'Factions');
const Wars = withProtection(WarsPage, 'Wars');
const Marketplace = withProtection(MarketplacePage, 'Marketplace');
const Leaderboards = withProtection(LeaderboardsPage, 'Leaderboards');
const Profile = withProtection(ProfilePage, 'Profile');
const Notifications = withProtection(NotificationsPage, 'Notifications');
const AdminPanel = withProtection(AdminPanelPage, 'AdminPanel');
const EconomyDashboard = withProtection(EconomyDashboardPage, 'EconomyDashboard');
const Quests = withProtection(QuestsAchievements, 'Quests');
const FactionChatPage = withProtection(FactionChat, 'FactionChat');
const SeasonalEvents = withProtection(SeasonalEventsPage, 'SeasonalEvents');
const SeasonPass = withProtection(SeasonPassPage, 'SeasonPass');
const EconomyStats = withScreenBoundary(EconomyStatisticsPage, 'EconomyStatistics');
const AdminDashboard = withProtection(AdminDashboardPage, 'AdminDashboard');

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary name="AppRoot">
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPass />} />
          <Route path="/economy-statistics" element={<EconomyStats />} />
          <Route path="/economy-stats" element={<EconomyStats />} />

          <Route path="/" element={<DashboardPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/stock-exchange" element={<StockExchangePage />} />
          <Route path="/stock-detail" element={<StockDetailPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/businesses" element={<BusinessesPage />} />
          <Route path="/crime-hub" element={<CrimeHubPage />} />
          <Route path="/jail" element={<Jail />} />
          <Route path="/factions" element={<Factions />} />
          <Route path="/wars" element={<Wars />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/leaderboards" element={<Leaderboards />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/economy-dashboard" element={<EconomyDashboard />} />
          <Route path="/quests-achievements" element={<Quests />} />
          <Route path="/faction-chat" element={<FactionChatPage />} />
          <Route path="/seasonal-events" element={<SeasonalEvents />} />
          <Route path="/season-pass" element={<SeasonPass />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
